import { Validator } from '@vista-digital/validator';
import { JourneyActionButtonType } from '../../../types/type';
import { defaultJourneyActionButtonGooglePayAssets, journeyActionButtonGooglePayAssetsValidator } from './assets';
import { defaultJourneyActionButtonGooglePayDisplayText, journeyActionButtonGooglePayDisplayTextValidator } from './display-text';
export const defaultJourneyActionButtonGooglePayProps = {
    type: JourneyActionButtonType.GooglePay,
    displayText: defaultJourneyActionButtonGooglePayDisplayText,
    assets: defaultJourneyActionButtonGooglePayAssets
};
export const journeyActionButtonGooglePayPropsValidator = Validator.object({
    type: Validator.isEqualTo(JourneyActionButtonType.GooglePay),
    displayText: journeyActionButtonGooglePayDisplayTextValidator,
    assets: journeyActionButtonGooglePayAssetsValidator
});
